import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../shared/Nav";
import Footer from "../shared/Footer";
import "../assets/css/variables.css";
import "../assets/css/global.css";
import "../assets/css/pages.css";

const API_URL = "https://accelia-backend.onrender.com/api/jobs";

const WHY = [
  {
    icon: "🚀",
    title: "Fast-Growing",
    desc: "Be part of one of India's fastest-growing SMOs — 30+ trials in just 18 months.",
  },
  {
    icon: "🌍",
    title: "Pan-India Impact",
    desc: "Work across multiple states and therapeutic areas with diverse sponsor portfolios.",
  },
  {
    icon: "🎓",
    title: "Continuous Learning",
    desc: "Access GCP workshops, training programs, and professional development opportunities.",
  },
  {
    icon: "🤝",
    title: "Collaborative Culture",
    desc: "A team-first environment where innovation, integrity, and excellence are celebrated.",
  },
];

export default function Careers() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await fetch(API_URL);
        const data = await res.json();
        setJobs(data.jobs || []);
      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  return (
    <>
      <Nav />

      <div className="page-wrapper">
        {/* HERO */}
        <div className="page-hero">
          <div className="sec-tag sec-tag--gold">Careers</div>
          <h1 className="sec-title sec-title--white">
            Join Accelia Clinical Solutions
          </h1>
        </div>

        {/* OPEN JOBS */}
        <section>
          <div className="sec-tag">Open Positions</div>
          <h2 className="sec-title">Current Openings</h2>

          <div className="job-list">
            {loading ? (
              <p className="sec-sub" style={{ textAlign: "center" }}>
                Loading jobs...
              </p>
            ) : jobs.length === 0 ? (
              <p className="sec-sub" style={{ textAlign: "center" }}>
                No open positions at the moment. Check back soon!
              </p>
            ) : (
              jobs.map((j) => (
                <div key={j._id} className="job-card">
                  <div className="job-info">
                    <h3>{j.title}</h3>
                    <div className="job-meta">
                      <span className="j-tag">{j.dept}</span>
                      <span>📍 {j.location}</span>
                      <span>⏱ {j.type}</span>
                      {j.salary && <span>💰 {j.salary}</span>}
                    </div>
                    {j.description && (
                      <p
                        style={{
                          fontSize: 13.5,
                          color: "#5E6E82",
                          marginTop: 8,
                          lineHeight: 1.6,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {j.description}
                      </p>
                    )}
                  </div>

                  {/* ✅ Navigate to dedicated Apply page — no modal */}
                  <button
                    className="btn-apply"
                    onClick={() => navigate(`/careers/apply/${j._id}`)}
                  >
                    Apply Now
                  </button>
                </div>
              ))
            )}
          </div>
        </section>

        {/* WHY SECTION */}
        <section style={{ background: "#F2F7FA" }}>
          <div className="sec-tag">Why Accelia</div>
          <h2 className="sec-title">Why Work With Us</h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill,minmax(235px,1fr))",
              gap: 18,
            }}
          >
            {WHY.map((item, i) => (
              <div key={i} className="why-card">
                <div>{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
